module.exports = __webpack_public_path__ + "img/avatar-26.24075812.png";